/**
 * This is where you configure the validation rules
 */

export default function ContactFormValidationRules(values) {
  let errors = {};

  // Name field
  if (!values.name) {
    errors.name = 'Required Your Full Name';
  }

  // Phone field
  if (!values.number) {
    errors.number = 'Required Your Phone Number';
  }

  // Email field
  if (!values.email) {
    errors.email = 'Required Your Email Address';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Invalid Email Address';
  }

  // Company name field
  if (!values.companyname) {
    errors.companyname = 'Required Your Company Name';
  }

  // Message name field
  if (!values.message) {
    errors.message = 'Required Your Requirements';
  }

  return errors;
}
